import {DialogManager} from '@modifi/plugin-dialogs'
import {CustomerDialogLayout} from '@modifi/ui'

import {DIALOG_IFRAME, IframeDialog} from './index'

// @ts-expect-error wrong typing by @modifi/ui
DialogManager.setDefaultLayout(CustomerDialogLayout)
DialogManager.addDialog(DIALOG_IFRAME, IframeDialog)
